/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutritionist.reducer';

export const NutritionistDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutritionistEntity = useAppSelector(state => state.nutritionist.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutritionistDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutritionist.detail.title">Nutritionist</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutritionist.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.id}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.nutritionist.education">Education</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.nutritionist.training">Training</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.nutritionist.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.nutritionist.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.achievements}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nutritionist.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nutritionist.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nutritionist.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nutritionist.active">Active</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nutritionist.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.nutritionist.name">Name</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.nutritionist.email">Email</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.email}</dd>
          <dt>
            <span id="visitCharge">
              <Translate contentKey="tinyMedicRestApp.nutritionist.visitCharge">Visit Charge</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.visitCharge}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.nutritionist.age">Age</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.nutritionist.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.nutritionist.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.nutritionist.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.nutritionist.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{nutritionistEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionist.tmUser">Tm User</Translate>
          </dt>
          <dd>{nutritionistEntity.tmUser ? nutritionistEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionist.contactCode">Contact Code</Translate>
          </dt>
          <dd>{nutritionistEntity.contactCode ? nutritionistEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionist.hospital">Hospital</Translate>
          </dt>
          <dd>{nutritionistEntity.hospital ? nutritionistEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nutritionist" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutritionist/${nutritionistEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutritionistDetail;
